<template>
  <div class="animated fadeIn">
    <b-alert :variant="dismissibleType"
             dismissible
             :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
      {{ errMsg }}
    </b-alert>
    <b-alert v-if="initLoad && !items.length" :variant="info" dismissible :show="true">
      Please wait while the server is spinning up it's cache. <b-btn @click="submitSearch">Reload</b-btn>
    </b-alert>
    <div>
      <b-row>
        <b-col>
          <b-card>

      <!-- User Interface controls -->
      <b-row>
        <b-col md="6" class="my-0">
          <b-form-group class="my-1">
            <b-input-group v-on:keyup.enter="submitSearch">
              <b-form-input v-model="tbxFilter" id="tbxFilter" placeholder="Type to Search" />
              <b-input-group-append>
                <b-btn @click="submitSearch">Search</b-btn>
              </b-input-group-append>
              <b-form-checkbox id="chkShowUnreconc" class="mx-3" v-model="filterUnrec" @change="submitSearch">Show Unreconciled Only</b-form-checkbox>
              <b-form-checkbox id="chkShowCPOUsedVehs" class="mx-3" v-model="filterCertified" @change="submitSearch">Show Certified Pre-Owned Used Vehicles Only</b-form-checkbox>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="2">
          <div style="text-align:right;" v-if="items.length">Last upload: {{ items[0].lastupload | formatDate }}</div>
        </b-col>
        <b-col md="2">
          <div style="text-align:right">Showing {{ getRowCount(items) }} / {{ totalCount }} records.</div>
        </b-col>
        <b-col md="2">
          <b-button id="btnAdd" class="pull-right" variant="outline-success" @click="$router.push('AddInventory')" title="Add">
            <i class="fa fa-plus-square"></i> <strong>Add</strong>
          </b-button>
        </b-col>
      </b-row>
      <!-- Main table element -->
      <b-table :items="items" :fields="fields" hover striped bordered small :current-page="currentPage" :per-page="perPage" show-empty @dblclick.stop="rowClickHandler" @row-clicked="rowClickHandler">
        <!--<template v-slot:cell(IS_NEW)="data">
    <span v-if="data.value">New</span>
    <span v-else>Used</span>
  </template>-->
        <template v-slot:cell(cost)="data">
          {{ data.value | currency('') }}
        </template>
        <template v-slot:cell(msrp)="data">
          {{ data.value | currency('') }}
        </template>
        <template v-slot:cell(price)="data">
          {{ data.value | currency('') }}
        </template>
        <template v-slot:cell(policy)="data">
          <table aria-busy="false" class="table b-table table-striped table-bordered table-sm table-xtra-condensed">
            <tbody>
              <tr v-for="p in data.item.policy">
                <td>
                  <small><strong>{{ p.partner }}</strong></small> {{ p.name }}
                </td>
              </tr>
            </tbody>
          </table>
        </template>
        <template v-slot:row-details="data">
          <b-table-column field="policy" label="Name" class="table-xtra-condensed">
            <span v-for="i in data.item.policy">{{ i.name }}</span>
          </b-table-column>
        </template>
        <template v-slot:cell(deletebutton)="data">
          <b-btn @click="DeleteInventoryItem(data.item.id)" class="btn btn-danger ml-2">
            <i title="DeleteInvItem" class="fa fa-trash fa-lg text-white"></i>
            <strong class="text-white">Delete</strong>
          </b-btn>
        </template>
      </b-table>

      <!-- NAV -->
      <nav>
        <b-pagination :total-rows="getRowCount(items)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" />
      </nav>

          </b-card>
        </b-col>
      </b-row>
    </div>

    <loading :show="boolLoading"
             :label="txtLoading">
    </loading>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import loading from 'vue-full-loading'
import Vue2Filters from 'vue2-filters'
import { setTimeout } from 'timers'

Vue.use(Vue2Filters)

export default {
  components: {
    loading
  },
  created () {
    var self = this
    setTimeout(function () {
      self.initLoad = true
      self.boolLoading = false
    }, 3500)

    axios.get('/api/inventory/loadlist')
      .then(response => {
        this.boolLoading = false
        this.initLoad = false
        this.totalCount = response.data.data.length
        this.items = response.data.data
        this.items.forEach(i => {
          if (i.status != 'Reconciled') { i._rowVariant = 'warning' }
        })
      })
      .catch(error => {
        if (error.response.status == 403) { this.$router.push('/login') }

        this.boolLoading = false
        this.errMsg = 'There was an error getting data : ' + error
        this.showDismissibleAlert = true
      })
  },
  data () {
    return {
      errMsg: '',
      dismissibleType: 'danger',
      showDismissibleAlert: false,
      initLoad: false,
      boolLoading: false,
      txtLoading: 'Loading...',

      filterUnrec: false,
      filterCertified: false,
      totalCount: 0,
      tbxFilter: '',
      items: [],
      fields: [
        { key: 'stock', label: 'Stock #', sortable: true },
        { key: 'VIN', label: 'VIN', sortable: true },
        { key: 'newused', label: 'Type', sortable: true },
        { key: 'year', label: 'Year', sortable: true },
        { key: 'make', label: 'Make', sortable: true },
        { key: 'model', label: 'Model', sortable: true },
        { key: 'description', label: 'Description', sortable: true },
        { key: 'modelnumber', label: 'Model #', sortable: true },
        // { key: 'extcolor', label: 'Ext Color', sortable: true },
        { key: 'cost', label: 'Cost', sortable: true },
        { key: 'msrp', label: 'MSRP', sortable: true },
        { key: 'price', label: 'Sticker Price', sortable: true },
        { key: 'lotage', label: 'Lot Age', sortable: true },
        { key: 'policy', label: 'Quoting Policy', sortable: true },
        { key: 'deletebutton', label: 'Delete?', sortable: false }
      ],
      currentPage: 1,
      perPage: 15,
      totalRows: 0
    }
  },
  methods: {
    rowClickHandler (record, index) {
      var selObj = window.getSelection()
      if (selObj.toString().length == 0) { this.$router.push('/EditInventory/' + record.id) }
    },
    getRowCount (items) {
      return items.length
    },
    submitSearch () {
      this.boolLoading = true
      let params = '?q=' + this.tbxFilter
      axios.get('/api/inventory/loadlist' + params)
        .then(response => {
          this.boolLoading = false
          this.totalCount = response.data.data.length
          this.items = response.data.data
          if (this.filterUnrec) {
            this.items = this.items.filter(f => { return f.status != 'Reconciled' })
          }
          if (this.filterCertified) {
            // console.log(JSON.stringify(this.items));
            this.items = this.items.filter(f => { return f.IS_NEW === 0 && f.certified === 1 })
          }

          this.items.forEach(i => {
            if (i.status != 'Reconciled') { i._rowVariant = 'warning' }
          })
        })
        .catch(error => {
          if (error.response.status == 403) { this.$router.push('/login') }

          this.boolLoading = false
          this.errMsg = 'There was an error getting data : ' + error
          this.showDismissibleAlert = true
        })
    },
    DeleteInventoryItem(itemid) {
      let obj =
      {
        vehicleInventoryID: itemid
      }

      axios.post('/api/inventory/deleteinventoryitem', obj)
        .then(response => {
          this.submitSearch()
        })
        .catch(error => {

        })
    }
    // addInventory() {
    //  let route = this.$router.resolve({ path: 'AddInventory' });
    //  window.open(route.href, '_blank');
    // },
  },
  filters: {
    formatDate: function (str) {
      if (!str) { return '' }
      str = new Date(str)
      return str.getFullYear() + '-' + ((str.getMonth() < 9) ? '0' : '') + (str.getMonth() + 1) + '-' +
          ((str.getDate() < 10) ? '0' : '') + str.getDate()
    }
  },
  mounted () {
    // boolLoading must be set to false on data() binding so that mount hooks the change
    this.boolLoading = true
    this.initLoad = false
  }
}
</script>

<style>
  .table > tbody > tr > td {
    /*vertical-align: middle;*/
  }

  .table-xtra-condensed > thead > tr > th,
  .table-xtra-condensed > tbody > tr > th,
  .table-xtra-condensed > tfoot > tr > th,
  .table-xtra-condensed > thead > tr > td,
  .table-xtra-condensed > tbody > tr > td,
  .table-xtra-condensed > tfoot > tr > td {
    padding: 2px 0.3rem;
  }
  .table-xtra-condensed.table {
    margin-bottom: initial !important;
  }
  body {
    background-color: initial;
  }
</style>



// WEBPACK FOOTER //
// src/views/Inventory.vue